import Cloak from 'cloak-auth/src/Client/Cloak';
import { StrictMode } from 'react';
import { Toaster } from 'react-hot-toast';
import { Outlet } from 'react-router-dom';

import { CameraWrapper } from 'kerberus-components/src/Components/Scan/QR/CameraWrapper';

import NextWrapper from '../Utils/NextWrapper';
import { RtcContainer } from '../Utils/RtcContainer';

export default function RootRoute() {
    return (
        <Cloak>
            <StrictMode>
                <CameraWrapper>
                    <Toaster position="top-center" reverseOrder={false} />
                    <NextWrapper>
                        <RtcContainer />
                    </NextWrapper>
                    <Outlet />
                </CameraWrapper>
            </StrictMode>
        </Cloak>
    );
}
